import { BeneficiaryLogo } from "@/modules/beneficiary/components";
import type { IBeneficiaryListOption } from "@/shared/common/types";
import { formatCardNumber } from "@/shared/helpers";
import { Divider } from "@ab.uitools/ui-library/components/Divider";
import { Text } from "@ab.uitools/ui-library/components/Text";

interface Props {
  list: IBeneficiaryListOption[];
  label: string;
  onItemClick: (value: string, name: string) => void;
  isBeneficiaryCards: boolean;
}

export const BeneficiaryGroup = ({
  list,
  label,
  onItemClick,
  isBeneficiaryCards
}: Props) => {
  if (!list.length) return null;
  return (
    <>
      <div className="px-16 py-8">
        <Text size="small" type="tertiary" weight="semibold">
          {label}
        </Text>
      </div>
      {list.map((beneficiary, index) => (
        <div
          key={beneficiary.number + index}
          className="flexbox cursor-pointer px-16"
          onClick={() => onItemClick(beneficiary.number, beneficiary.name)}
        >
          <div className="mt-16">
            <BeneficiaryLogo name={beneficiary.name}/>
          </div>
          <div className="full-width flexbox flex-direction--column pl-16">
            {!!index && <Divider color="light" type="primary" isHorizontal/>}
            <div className="flexbox full-width beneficiary-item-body-wrapper py-16">
              <div>
                <Text className="beneficiary-name pr-16" size="medium" weight="semibold">
                  {beneficiary.name}
                </Text>
                <Text type="tertiary" weight="semibold">
                  {isBeneficiaryCards ? formatCardNumber({ card: beneficiary.number }) : beneficiary.number}
                </Text>
                <Text type="tertiary">{beneficiary.note}</Text>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
